<template>
  <div
    :class="alertClass"
    role="alert"
  >
    <div
      v-if="icon !== null"
      :class="`${prefixClass}alert-icon`"
    >
      <i :class="iconTypeClass" />
    </div>
    <div :class="[
      `${prefixClass}alert-content`,
      {
        'pt-1': !title
      }
    ]">
      <div
        v-if="title"
        :class="`${prefixClass}alert-title`"
      >
        {{ title }}
      </div>
      <div :class="`${prefixClass}alert-description`" v-html="sanitizeDesc" />
      <div
        v-if="linksText.length || $slots.link"
        :class="`${prefixClass}alert-link`"
      >
        <slot name="link">
          <a
            v-for="(text, index) in linksText"
            :key="`link-text-${index}`"
            :href="linksHref[index]"
            :target="linksTarget[index]"
            :class="index + 1 !== linksText.length ? 'mr-4': null"
          >
            {{ text }}
          </a>
        </slot>
      </div>
    </div>
    <button
      @click="clickClose"
      type="button"
      class="close"
      data-dismiss="alert"
      aria-label="Close"
      v-if="dismissible"
    >
      <i class="ic ic-reset" />
    </button>
  </div>
</template>

<script>
import xss from 'xss';

export default {
  name: 'Alert',
  props: {
    type: {
      type: String,
      default: 'success',
    },
    icon: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    toast: {
      type: Boolean,
      default: false,
    },
    dismissible: {
      type: Boolean,
      default: false,
    },
    prefixClass: {
      type: String,
      default: '',
    },
    linksText: {
      type: Array,
      default: () => [],
    },
    linksHref: {
      type: Array,
      default: () => [],
    },
    linksTarget: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    sanitizeDesc() {
      return xss(this.description);
    },
    alertClass() {
      const cls = [`${this.prefixClass}alert`, `${this.prefixClass}alert-${this.type}`];
      if (this.title === null && this.size === 'small') cls.push(`${this.prefixClass}alert-small`);
      if (this.toast) cls.push(`${this.prefixClass}alert-toast`);
      if (this.dismissible) cls.push(`${this.prefixClass}alert-dismissible`);

      return cls;
    },
    defaultIconType() {
      const types = {
        success: 'success',
        info: 'info',
        warning: 'warning',
        error: 'error',
      };

      return types[this.type];
    },
    iconTypeClass() {
      const cls = ['ic'];

      if (this.icon === 'default') cls.push(`ic-${this.defaultIconType}`);
      else cls.push(`ic-${this.icon}`);

      return cls;
    },
  },
  methods: {
    clickClose() {
      this.$emit('close');
    },
  },
};
</script>
